class ReusableCardController {


    public icon: string;
    public iconClass: string;
    public heading: string;
    public title: string;
    public cardClass: string = '';
    public loading: boolean = false;
    public collapsible: boolean = false;
    public isCollapsed: boolean = false;
    public hideHeader: boolean = false;

    constructor(private $transclude: ng.ITranscludeFunction) {

    }

    public hasFooterContent(): boolean {
        return this.$transclude.isSlotFilled('footer');
    }

    public toggleCollapse(): void {
        if (this.collapsible === true) {
            this.isCollapsed = !this.isCollapsed;
        }
    }
}

export const ReusableCardComponent = {
    template: require('./reusable-card.component.html'),
    style: require('./reusable-card.component.scss'),
    controller: ReusableCardController,
    controllerAs: '$ctrl',
    bindings: {
        icon: '@',
        iconClass: '@?',
        /** Card heading text. Prefer `heading` over `title` when you need the label without a native tooltip on the host element. */
        heading: '@?',
        title: '@',
        cardClass: '@?',
        loading: '<?',
        collapsible: '<?',
        isCollapsed: '=?',
        hideHeader: '<?'
    },
    transclude: {
        content: 'cardContent',
        footer: '?cardFooter',
        headerActions: '?cardHeaderActions'
    }
};



// WEBPACK FOOTER //
// ./src/components/reusable-card/reusable-card.component.ts